module.exports = __webpack_public_path__ + "static/img/cooperative_partner_7.14d9b9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperative_partner_7.png
// module id = r32v
// module chunks = 0